import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import type { TimeframePreset } from "@/hooks/useAdminData";

interface Props {
  preset: TimeframePreset;
  customFrom: string;
  customTo: string;
  presets: { value: TimeframePreset; label: string }[];
  onPresetChange: (p: TimeframePreset) => void;
  onCustomRangeChange: (from: string, to: string) => void;
}

export function AdminTimeframeFilter({ preset, customFrom, customTo, presets, onPresetChange, onCustomRangeChange }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {presets.map((p) => (
        <Button
          key={p.value}
          variant={preset === p.value ? "default" : "outline"}
          size="sm"
          className={cn("h-8 text-xs", preset === p.value && "pointer-events-none")}
          onClick={() => onPresetChange(p.value)}
        >
          {p.label}
        </Button>
      ))}
      {preset === "custom" && (
        <div className="flex items-center gap-2">
          <Input
            type="datetime-local"
            className="h-8 w-auto text-xs"
            value={customFrom}
            onChange={(e) => onCustomRangeChange(e.target.value, customTo)}
          />
          <span className="text-xs text-muted-foreground">to</span>
          <Input
            type="datetime-local"
            className="h-8 w-auto text-xs"
            value={customTo}
            onChange={(e) => onCustomRangeChange(customFrom, e.target.value)}
          />
        </div>
      )}
    </div>
  );
}
